'use client'
import { useForm } from 'react-hook-form'
import { useProductStore } from '@/store/product/product-store'
import { useFilter } from '@/hooks/useFilter'
import FilterInputGroup from './form/FilterInputGroup'
import FilterSelectGroup from './form/FilterSelectGroup'
import { Button } from './ui/Button'
import { useEffect, useMemo } from 'react'
import { setFilterSide } from './fieldsSideFilter'
import { inter } from '@/config/fonts'
import { Title } from './Title'
import Hr from './ui/Hr'

interface PropsSize {
  label: string
  value: string
}

export interface FormInputs {
  productSizeId?: PropsSize
  productWidthId?: PropsSize
  productHeightId?: PropsSize
  title?: string
  categoryId?: string
  brandId?: string
  category?: string
  brand?: string
}

interface FilterProductProps {
  menuItems: any[]
  productAttr: any
  className?: string
}

const FilterProduct: React.FC<FilterProductProps> = ({
  menuItems,
  productAttr,
  className = '',
}) => {
  const totalResult = useProductStore((state) => state.totalResult)

  useEffect(() => {}, [menuItems])

  const {
    handleSubmit,
    formState: { isValid },
    setValue,
    control,
    reset,
  } = useForm<FormInputs>({
    defaultValues: {
      productSizeId: { label: 'Todos', value: '' },
      productWidthId: { label: 'Todos', value: '' },
      productHeightId: { label: 'Todos', value: '' },
      brandId: '',
      brand: '',
      categoryId: '',
      category: '',
    },
  })

  const { subItems, onSubmit, setCategory, setBrand, resetButton } = useFilter({
    setValue,
    reset,
  })

  const { fieldsSizes, fieldCategory, fieldBrand } = useMemo(
    () =>
      setFilterSide({
        control,
        productAttr,
        setBrand,
        setCategory,
        setValue,
      }),
    [control, setValue, productAttr],
  )

  return (
    <>
      <Title
        classNameContainer={'flex justify-center items-center'}
        classNameTitle={`${inter.className} text-xl text-blue-800 font-bold text-center`}
        title={`Resultados: ${totalResult ? `${totalResult}` : '0'}`}
      />
      <div className={`flex flex-col items-center ${className}`}>
        <div className="mr-6 w-64">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="grid w-full px-5 mb-4 grid-cols-1 gap-3 sm:px-0 min-w-[290px] "
          >
            <div className="flex flex-col gap-1 items-center mb-2">
              <FilterSelectGroup
                data={fieldsSizes}
                className="mt-2 mb-2 w-60 mr-8 sm:mr-2"
              />
              <FilterInputGroup
                title="Tipo Cubierta"
                fileds={fieldCategory || []}
                data={menuItems || []}
              />
              <FilterInputGroup
                key={`brands-${subItems.length}`}
                title="Marca"
                fileds={fieldBrand || []}
                data={subItems || []}
              />
              <Hr className="border-t w-64 mr-6" />
              <div className="flex gap-4 mt-2 sm:mt-4 mb-8 mr-6">
                <Button
                  title="Borrar Filtro"
                  onClick={resetButton}
                  type="reset"
                  className="w-[130px] p-2 px-4 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-all"
                />
                <Button
                  title="Buscar"
                  type="submit"
                  className="w-[130px] p-2 px-4 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-all"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default FilterProduct
